import * as React from 'react';
import { StoreContext } from '../utils';
import { Store } from '../store/Store';

export class SigninButtonCode extends React.Component {
  static contextType = StoreContext;
  declare context: Store;

  get buttonText() {
    if (this.context.requestStore.requestLocation.pathurl.includes('signin')) {
      return 'Weiter mit Anmelde-Code';
    }
    return 'Anmelden mit Anmelde-Code';
  }

  render() {
    const {} = this.context;

    return (
      <a href="/auth/code" className="btn btn-light-primary font-weight-bolder px-8 py-4 my-3 font-size-lg">
        <span className="svg-icon svg-icon-md">
          {/*begin::Svg Icon | path:assets/media/svg/social-icons/google.svg*/}
          <i className="fas fa-user-graduate"></i>
          {/*end::Svg Icon*/}
        </span>
        {this.buttonText}
      </a>
    );
  }
}
